<template>
  <v-app id="inspire">
    <!-- Desktop Header -->
    <v-container class="purple darken-3 py-1 d-none d-md-block" fluid>
      <v-container>
        <div class="d-flex">
          <div class="d-none d-md-flex">
            <v-avatar size="70"><v-img src="@/assets/pea-logo.png"></v-img></v-avatar>
          </div>
          <div class="d-md-none">
            <v-avatar size="45"><v-img src="@/assets/pea-logo.png"></v-img></v-avatar>
          </div>
          <div class="d-flex flex-column justify-center pl-3">
            <div class="text-h5 white--text header-title">
              ระบบบริหารจัดการข้อมูลผู้ผลิตไฟฟ้าจากพลังงานทดแทน
            </div>
            <div class="subtitle-1 header-subtitle d-none d-md-flex amber--text text--lighten-2">
              Power Producer Information Management System (PPIM)
            </div>
          </div>
        </div>
      </v-container>
    </v-container>
    <v-container class="purple darken-1 pa-0 d-none d-md-block" fluid>
      <v-container class="py-2">
        <div class="d-flex justify-content-between">
          <v-btn v-for="link in main_menu" :key="link.title" text color="white" exact :to="link.url">
            <v-icon small class="pr-2">{{ link.icon }}</v-icon>{{ link.title }}
          </v-btn>
          <v-menu rounded="0" bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-for="item in linkProject" :key="item.title" color="white" text v-bind="attrs" v-on="on">
                {{ item.title }}
                <v-icon small class="pl-2">{{ item.caret }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="item in itemProject" :key="item.title" :to="item.url">
                <v-list-item-title>
                  <v-icon small class="pr-2">{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn v-if="auth" color="white" text id="track" @click="track = true">
            ติดตามสถานะ
            <v-icon small class="pl-2">fas fa-caret-down</v-icon>
          </v-btn>
          <v-menu rounded="0" bottom offset-y activator="#track" v-model="track">
            <v-list>
              <v-list-item v-for="item in itemStatus" :key="item.title" :to="item.url">
                <v-list-item-title>
                  <v-icon small class="pr-2">{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>
          <v-menu v-if="!auth" rounded="0" bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-for="item in linkRegister" :key="item.title" color="white" text v-bind="attrs" v-on="on">
                {{ item.title }}
                <v-icon small class="pl-2">{{ item.caret }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="item in itemRegister" :key="item.title" :to="item.url">
                <v-list-item-title>
                  <v-icon small class="pr-2">{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn v-if="auth" text>
            <v-icon small color="white" class="pr-2">fas fa-user-circle</v-icon><span
              class="white--text text-lowercase">{{ user
              }}</span>
          </v-btn>
          <v-btn v-if="!auth" text color="white" :to="linkSignIn[0].url">
            <v-icon small class="pr-2">{{ linkSignIn[0].icon }}</v-icon>{{ linkSignIn[0].title }}
          </v-btn>
          <v-btn v-else v-for="link in linkSignOut" :key="link.title" text color="white" :to="link.url">
            <v-icon small class="pr-2">{{ link.icon }}</v-icon>{{ link.title }}
          </v-btn>
        </div>
      </v-container>
    </v-container>
    <!-- Mobile Header -->
    <v-toolbar dark dense flat color="purple darken-3" class="d-md-none header-title flex-grow-0 flex-shrink-0">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <div class="d-none d-sm-inline">
        <v-toolbar-title class="">ระบบบริหารจัดการข้อมูลผู้ผลิตไฟฟ้าจากพลังงานทดแทน</v-toolbar-title>
      </div>
      <div class="d-sm-none">
        <v-toolbar-title>PPIM</v-toolbar-title>
      </div>
    </v-toolbar>
    <v-navigation-drawer v-model="drawer" absolute temporary app>
      <v-list nav dense>
        <v-list-item v-for="link in main_menu" :key="link.title" link exact :to="link.url">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-divider></v-divider>
        <v-list nav dense>
          <v-list-group v-if="!auth" v-for="link in linkRegister" :key="link.title" v-model="link.active"
            :prepend-icon="link.icon" no-action color="purple">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="link.title"></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="item in itemRegister" :key="item.title" class="pl-10" :to="item.url">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-if="auth">
            <v-list-item-icon>
              <v-icon>fas fa-user-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ user }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!auth" v-for="link in linkSignIn" :key="link.title" link :to="link.url">
            <v-list-item-icon>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-else link :to="linkSignOut[0].url">
            <v-list-item-icon>
              <v-icon>{{ linkSignOut[0].icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ linkSignOut[0].title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <v-col cols="12">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer padless color="grey lighten-3" class="d-none d-sm-block">
      <v-col class="text-center text-body-2" cols="12">
        <v-divider></v-divider>
        <p class="pt-5">
          กองส่งเสริมพลังงานทดแทนและผู้ผลิตไฟฟ้าขนาดเล็ก การไฟฟ้าส่วนภูมิภาค
        </p>
        <p>
          © {{ new Date().getFullYear() }} Provincial Electricity Authority, All
          rights reserved.
        </p>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    linkProject: [
      {
        title: "โครงการที่ดำเนินการ",
        icon: "fas fa-id-card",
        caret: "fas fa-caret-down",
        url: "#"
      }
    ],
    linkRegister: [
      {
        title: "ลงทะเบียน",
        icon: "fas fa-id-card",
        caret: "fas fa-caret-down",
        url: "#"
      }
    ],
    linkSignIn: [
      { title: "เข้าสู่ระบบ", icon: "fas fa-sign-in-alt", url: "/login" }
    ],
    linkSignOut: [
      { title: "ออกจากระบบ", icon: "fas fa-sign-out-alt", url: "/logout" }
    ],
    itemProject: [
      {
        title: "การรับคำขอเชื่อมต่อเครื่องกำเนิดไฟฟ้า",
        icon: "fas fa-project-diagram",
        url: { name: "project-parallel-list" }
      },
      {
        title: "โครงการรับคำเสนอขอขายไฟฟ้า",
        icon: "fas fa-plug",
        url: { name: "project-eco-list" }
      }
    ],
    itemRegister: [
      {
        title: "นิติบุคคล",
        icon: "fas fa-building",
        url: { name: "register-organization" }
      },
      {
        title: "บุคคลทั่วไป",
        icon: "fas fa-user",
        url: { name: "register-personal" }
      }
    ],
    itemStatus: [
      {
        title: "การรับคำขอเชื่อมต่อเครื่องกำเนิดไฟฟ้า",
        icon: "fas fa-project-diagram",
        url: { name: "ongrid-track" }
      },
      {
        title: "โครงการรับคำเสนอขอขายไฟฟ้า",
        icon: "fas fa-history",
        url: { name: "request-eco-list" }
      }
    ],

    drawer: false,
    group: null,
    track: false
  }),
  computed: {
    ...mapGetters("auth", {
      auth: "isAuthenticated",
      user: "user"
    }),
    main_menu() {
      let links = [{ title: "หน้าแรก", icon: "fas fa-home", url: "/home" }];

      return links;
    }
  },
  watch: {
    group() {
      this.drawer = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.header-title,
.header-subtitle,
.v-list-item,
.v-list-item__title,
button,
a.v-btn {
  font-family: "Prompt", sans-serif !important;
}

button,
a.v-btn {
  font-weight: 400;
}

.v-list-item .v-list-item__title {
  font-size: 0.9rem;
  line-height: 1.2rem;
}
</style>
